/**
 * Sanitizes a filename by converting spaces to hyphens, making it lowercase,
 * providing a default name for empty or whitespace-only strings, and limiting
 * the length to a maximum of 35 characters.
 *
 * @param filename - The original filename string
 * @param defaultName - The default name to use if the filename is empty or only whitespace
 * @returns The sanitized filename (max 35 characters)
 *
 * @example
 * sanitizeFilename(" Bitpanda T&C ", "document") // "bitpanda-t&c"
 * sanitizeFilename("   ", "document") // "document"
 * sanitizeFilename("", "document") // "document"
 * sanitizeFilename("Annual Report 2024") // "annual-report-2024"
 * sanitizeFilename("Very Long Document Name That Exceeds The Limit") // "very-long-document-name-that-exceed"
 */
export const sanitizeFilename = (
  filename: string,
  defaultName = 'document',
): string => {
  const sanitized = filename.trim().toLowerCase().replace(/\s+/g, '-');

  // If the result is empty (was only spaces) or becomes empty after sanitization
  const result = sanitized || defaultName;

  // Limit to 35 characters maximum
  return result.length > 35 ? result.substring(0, 35) : result;
};
